import { IIndexTypeCategory } from "../model/IndexTypeCategory";
import IndexTypeCategoryMapper from "../service/IndexTypeCategoryMapper";
import IndexTypeCategoryParamMapper from "../service/IndexTypeCategoryParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";

export default class FindConnectionCandidatesForCategoryInteractor {
  private resource: GetResourceEntriesInteractor<IIndexTypeCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(indexTypeCategoryId: number) {
    return this.resource.execute(
      `/index-type-categories/${indexTypeCategoryId}/candidates`,
      IndexTypeCategoryMapper,
      IndexTypeCategoryParamMapper
    );
  }
}
